export default "__VITE_ASSET__TNDh1a7K__"